import React from 'react';

// Own constants/actions/components
import Router from 'router/Router';

const App = () => {
  return (
    <div>
      <Router />
    </div>
  );
};

export default App;
